/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSavingsHomeAndAppletSyncEntityRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetSavingsHomeAndAppletSyncEntityResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getSavingsHomeAndAppletSyncEntity = (request: GetSavingsHomeAndAppletSyncEntityRequest, options?: CashRequestOptions) => post<GetSavingsHomeAndAppletSyncEntityRequest, GetSavingsHomeAndAppletSyncEntityResponse>("/2.0/cash/get-savings-home-and-applet-sync-entity", request, {...options, rejectOnError: true })